import Meta from "@components/partials/seo-meta";

export default function Resum2022() {
  return (
    <>
      <Meta
        title="2022 en xifres - Cultura Cardedeu"
        description="2022 en xifres, resum de l'any - Cultura Cardedeu és una iniciativa ciutadana per veure en un cop d'ull tots els actes culturals que es fan a Cardedeu."
        canonical="https://www.culturacardedeu.com/2022-en-xifres"
      />

      <div
        dangerouslySetInnerHTML={{
          __html:
            '<iframe src="https://coda.io/embed/v9-2cxRs-j/_suMTl?&hideSections=true" width=1200 height=900 frameBorder="0"style="max-width: 100%; margin:-8px; margin-top:-58px;" allow="fullscreen "></iframe>',
        }}
      />
    </>
  );
}
